import getErrors from '../../../../shared/lib/geterrors';
import ResponsabileareaService from '../../../../shared/services/api/responsabilearea';

export const onResponsabileareaSubmit = (
  values,
  { setSubmitting, setErrors, setValues },
  { anagraficaId, update, notifications }
) => {
  const payload = {
    ...values,
    anagrafica: anagraficaId,
    contratto: {
      id: values.contratto_id || null,
      numero: values.contratto_numero ? values.contratto_numero : '',
      dataDecorrenza: values.contratto_dataDecorrenza ? +values.contratto_dataDecorrenza.format('X') : '',
      dataRescissione: values.contratto_dataRescissione ? +values.contratto_dataRescissione.format('X') : '',
    },
  };

  delete payload.contratto_dataDecorrenza;
  delete payload.contratto_dataRescissione;
  delete payload.contratto_id;
  delete payload.contratto_numero;
  delete payload.contratto_attivo;

  if (!values.id || values.id.length === 0) {
    ResponsabileareaService.create(payload)
    .then((data) => {
      setSubmitting(false);

      // Update form values if needed
      setValues({ ...values, id: data.id });

      // Success notification
      notifications.addNotification({
        message: 'Dati responsabile area salvati',
        level: 'success',
      });

      // Update parent list
      update();
    })
    .catch((errors) => {
      const errorsObj = getErrors(errors);
      setSubmitting(false);
      setErrors(errorsObj);

      // Error notification
      notifications.addNotification({
        message: 'Si è verificato un problema con il salvataggio del responsabile area, ricontrolla i campi inseriti',
        level: 'error',
      });
    });
  } else {
    ResponsabileareaService.put(payload)
      .then(() => {
        setSubmitting(false);
        notifications.addNotification({
          message: 'Dati responsabile area aggiornati',
          level: 'success',
        });
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        setSubmitting(false);
        setErrors(errorsObj);

        // Error notification
        notifications.addNotification({
          message: 'Si è verificato un problema con il salvataggio del responsabile area, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  }
};

export default onResponsabileareaSubmit;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/ResponsabileArea/submit.js